/**
 * Root screens where Android Back button should exit the app
 * instead of navigating back.
 * 
 * These are the "home" screens of main navigation tabs or entry points.
 */
export const ROOT_SCREENS: string[] = [
  '/',
  '/splash',
  '/welcome',
  '/catalog',
  '/favorites',
  '/chats',
  '/profile',
];

/**
 * Check if a pathname is a root screen
 * Supports exact match and paths with query params
 */
export function isRootScreen(pathname: string): boolean {
  return ROOT_SCREENS.some(root => 
    pathname === root || 
    pathname.startsWith(root + '?')
  );
}
